import { ChatBubbleBottomCenterTextIcon } from '@heroicons/react/24/outline';
import EmptyStateNew from '../../../../components/empty-state/EmptyStateNew';
import { useState } from 'react';
import NewComment from './NewComment';

type NoCommentsHelperProps = {
    worksheetId: string;
    disableAction: boolean;
};

function NoCommentsHelper({ worksheetId, disableAction }: NoCommentsHelperProps): JSX.Element {
    const [newComment, setNewComment] = useState(false);

    if (newComment) {
        return <NewComment worksheetId={worksheetId} onAction={(): void => setNewComment(false)} expanded />;
    }

    return (
        <div className="my-4">
            <EmptyStateNew
                actionButtonType="secondary"
                title="No Comments"
                icon={<ChatBubbleBottomCenterTextIcon />}
                titleSize="small"
                helpText="Create threads contextualised to this worksheet."
                helpLink="https://learn.cimplico.com/docs/worksheet-comments"
                actionText="New Comment"
                disableActionButton={disableAction}
                onClick={(): void => setNewComment(true)}
            />
        </div>
    );
}

export default NoCommentsHelper;
